// Migrado VERBATIM de context/DarkMode/index.js (THEME_CONFIGS.light).
import { KR, sharedComponents } from "./shared";

export default {
  muiMode: "light",
  scrollbarColor: KR.borderStrong,
  palette: {
    primary:    { main: KR.brand },
    secondary:  { main: KR.inkSecond },
    background: { default: KR.baseLight, paper: KR.surfaceLight },
    text:       { primary: KR.ink, secondary: KR.inkSecond },
    divider:    KR.borderLight,
    action: {
      hover:    "rgba(0,0,0,0.04)",
      selected: KR.brandSubtle,
    },
  },
  components: {
    ...sharedComponents,
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          backgroundColor: KR.surfaceLight,
        },
        notchedOutline: { borderColor: KR.borderStrong },
      },
    },
  },
  custom: {
    chat: { sentBg: "#FFF3E8", quotedSentBg: "#FFE8D0", quotedReceivedBg: "#f0f0f0", accent: "#F37021" },
    chartPalette: ["#F37021", "#0071BC", "#273A74", "#4CAF50", "#E74C3C", "#8B5CF6"],
    login: { bg: "#555A5F" },
  },
};
